import { post } from '../fetch'

export const createSession = (payload) => {
  return post(`auth/telegram-passport/session`, payload)
}

export const login = (payload) => {
  return post(`auth/telegram-passport/login`, payload)
}
